import type { ErrorInfo } from 'react';
import { Component, useEffect, useState, type HTMLProps } from 'react';
import { useLocation } from 'react-router-dom';

interface ErrorManagerProps extends HTMLProps<HTMLDivElement> {
  hasError: boolean;
}

function ErrorManager({ hasError, children }: ErrorManagerProps) {
  const { pathname } = useLocation();
  const [fatal, _setFatal] = useState<boolean>(false);

  useEffect(() => {
    // if ( hasError )
    // {
    //     if ( !['', '/', '/home', '/security/login'].includes(pathname) )
    //     {
    //         window.location.href = '/';
    //     }
    //     else
    //     {
    //         setFatal(true);
    //     }
    // }
  }, [pathname, hasError]);

  if (fatal) {
    console.error(hasError);
    return <p>Erreur fatale !</p>;
  }

  return children;
}

export default class ErrorBoundary extends Component<
  HTMLProps<HTMLDivElement>,
  { hasError: boolean }
> {
  constructor(props: HTMLProps<HTMLDivElement>) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.log(error, info.componentStack);
  }

  override render() {
    return (
      <ErrorManager hasError={this.state.hasError}>
        {this.props.children}
      </ErrorManager>
    );
  }
}
